let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        'drawer-mobile-menu',
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )
      .then(res => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['drawer-mobile-menu'],
        )
        const myself = newDOM.querySelector(this.localName)

        this.innerHTML = myself.innerHTML

        this.querySelectorAll('[data-nav-parent]').forEach(tab => {
          tab.addEventListener('click', this.handleTabClick.bind(this))
        })

        document.dispatchEvent(new CustomEvent('menuLoaded'))
      })
      .catch(() => {})
  }

  handleTabClick (event) {
    const itemEl = event.currentTarget
    const tabs = document.querySelectorAll('[data-nav-parent]')
    const selectedTab = itemEl.dataset.navParent
    const panels = document.querySelectorAll('[data-nav-menu]')
    const selectedPanelAll = document.querySelectorAll(
      `[data-nav-menu="${selectedTab}"]`,
    )

    tabs.forEach(tab => {
      tab.setAttribute('aria-pressed', 'false')
    })

    panels.forEach(panel => {
      panel.setAttribute('aria-hidden', 'true')
    })

    selectedPanelAll.forEach(section => {
      section.setAttribute('aria-hidden', 'false')
    })

    itemEl.setAttribute('aria-pressed', 'true')
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
